import React from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { SettingBar } from 'handimap-react-lib/containers/SettingBar';
import { setOpenDrawer } from 'handimap-react-lib/store/actions/sideBarActions';

export const LayerBarSectionMobile = () => {

  const dispatch = useDispatch();
  const {t} = useTranslation();

  const closeLayerSection = () => {
    dispatch(setOpenDrawer(false));
  };

  const styles = {
    container : {
      display: 'flex',
      width: '100vw',
    },
    titleContainer: {
      display: 'flex',
      paddingX: '1em'
    },
    title: {
      fontSize: '2em'
    },
    closeContainer : {
      display: 'flex',
      flexGrow: 1,
      justifyContent: 'flex-end',
      padding: '1em',
    },
    listContainer : {
      display: 'flex',
      paddingX: '1em'
    }
  };
  return (
    <Stack sx={styles.container} spacing={2}>
      <Box sx={styles.closeContainer}>
        <IconButton 
          id='layer_settings_close'
          aria-label={t('layer.close')}
          onClick={closeLayerSection}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Box sx={styles.titleContainer}>
        <Typography variant='h1' sx={styles.title}>
          {t('layer.layer-label')}
        </Typography>
      </Box>
      <Box sx={styles.listContainer}>
        <SettingBar direction = 'column' />
      </Box>
    </Stack>
  );
};